export const __Moneda = "ARS";
export const __ClaveEnc = "21297617";
export const __MapsApi = "AIzaSyA9f-ptO1DfEXc2sPIxhjiYNVoGXdPV64I";
export const __UrlRedireccion = "https://formulaquim-3e6cd.web.app/Login";
export const __FechaFormat = "dd/MM/yyyy";
export const __Rutas = {
  Home: "/",
  Catalogo: "/Catalogo/:cabecera",
  Login: "/Login",
  Registro: "/Registro",
  Carrito: "/Carrito",
  Historial: "/Historial",
};

export const __Colecciones = {
  Catalogo: "Catalogo",
  Clasificacion: "Clasificacion",
  Cotizacion: "Cotizacion",
  Cliente: "Cliente",
  Sucursal: "Sucursal",
};
